import { observable } from 'mobx';
import { CourierApi } from '~api/CourierApi';
import { Courier } from '~domain/entities/Courier';
import { ICourierRequest } from '~interfaces/ICourierInterfaces';

export class CourierRepository {
    @observable public curier: Courier;
    @observable public status: number = 0;
    @observable public courierApi: CourierApi;

    constructor(courierApi: CourierApi) {
        this.courierApi = courierApi;
    }

    public getCourierQuote = async (courierRequest: ICourierRequest) => {
        const courierResponse = await this.courierApi.getCourierQuote(courierRequest);
        this.curier = Courier.fromJson(courierResponse[0]?.result?.value);
    };

    public getCourierAvailable = () => {
        return this.status;
    };
}
